import React, {Component} from 'react';
import ResultsView from "../views/ResultsView";
import {FormUtility, withRouter} from "cw-styleguide-react";
import {route} from "../../../routes";

class ResultsController extends Component {
  constructor(props) {
    super(props);

    const parameters = this.props.convertParametersToFilters(this.props.location.search);

    let merged = {...{
      courseId:"",
      courseTitle:"",
      keyword:"",
      location:"",
      proximity: "5",
      qualificationType: new Set(),
      studyMethodType: new Set(),
      studyMethodHours: new Set(),
      studyMethodTimes: new Set(),
      programme: new Set(),
      courseType: new Set(),
      courseGroupType: new Set(),
      mainProviderId:"",
      mainProviderLabel:"",
      order:"titleAsc",
      page:1,
      groupSize:'10'

    }, ...parameters}

    this.state = {
      filterValues: merged,
      formErrors:[],
      reloadKey: Math.random()
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleStateChange = this.handleStateChange.bind(this);
  }

  /**
   * Handle the form change event and set the values in the form state.
   * @param event
   */
  handleChange(event) {
    const values = {...this.state.filterValues};
    this.setState({
      filterValues: FormUtility.setFormValues(event, values)
    });

  }

  /**
   * handleClear
   * @param id
   */
  handleClear(id, value="") {
    const values = {...this.state.filterValues};
    values[id] = value;
    this.setState({
      filterValues: values,

    });
    this.props.resetQuery();
  }


  /**
   * handleReset
   * @param event
   */
  handleReset(event) {

    this.setState({
      filterValues: {
        courseId:"",
        courseTitle:"",
        keyword:"",
        location:"",
        proximity: "5",
        qualificationType: new Set(),
        studyMethodType: new Set(),
        studyMethodHours: new Set(),
        studyMethodTimes: new Set(),
        programme: new Set(),
        courseType: new Set(),
        courseGroupType: new Set(),
        mainProviderId:"",
        mainProviderLabel:"",
        order:"titleAsc",
        page:1,
        groupSize:'10'
      },
      reloadKey: Math.random()
    }, ()=> {
      this.props.navigate(route('results'));
      this.props.styleguide.setLanguageUrl(route('results',null,this.props.i18n.language === 'cy' ? 'en' : 'cy'));
      this.props.resetQuery();
    });
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.props.setQuery(this.props.location.search);
    this.props.styleguide.setLanguageUrl(route('results',null,this.props.i18n.language === 'cy' ? 'en' : 'cy') + this.props.location.search);
  }

  /**
   * handleSubmit
   * @param event
   */
  handleSubmit(event) {
    event.preventDefault();


    console.log(this.state.filterValues);

    let parameters = this.props.convertFiltersToParameters(this.state.filterValues);
    this.props.styleguide.setLanguageUrl(route('results',null,this.props.i18n.language === 'cy' ? 'en' : 'cy') + parameters);


    this.props.navigate(route('results') + parameters);
    this.props.setQuery(parameters);
    this.setState({
      reloadKey: Math.random()
    }, ()=> {

    });
  }


  handleStateChange(data) {
    const values = {...this.state.filterValues};
    values['order'] = data.order;
    values['groupSize'] = data.groupSize;
    values['page'] = data.page;

    this.setState({
      filterValues: values,
    }, ()=> {
      let parameters = this.props.convertFiltersToParameters(this.state.filterValues);
      this.props.styleguide.setLanguageUrl(route('results',null,this.props.i18n.language === 'cy' ? 'en' : 'cy') + parameters);
      this.props.navigate(route('results') + parameters);

      this.props.setQuery(parameters);
    });


  }

  /**
   * render
   * @returns {JSX.Element}
   */
  render() {

    return <ResultsView {...this.props} {...this.state}
                        handleChange={this.handleChange}
                        handleSubmit={this.handleSubmit}
                        handleReset={this.handleReset}
                        handleClear={this.handleClear}
                        handleStateChange={this.handleStateChange}
    />;
  }
}

export default withRouter(ResultsController);
